import type { HubButtonStyleProps } from '@adflow/frontend/ui-buttons';
import { hubButtonStyle } from '@adflow/frontend/ui-buttons';

import type { LinkNavActionProps } from './nav-action';
import { LinkNavAction } from './nav-action';

export interface LinkButtonProps
	extends
		HubButtonStyleProps,
		Omit<LinkNavActionProps, keyof HubButtonStyleProps> {
	disabled?: boolean;
}

export function LinkButton({
	color,
	variant,
	size,
	disabled,
	...linkProps
}: LinkButtonProps) {
	const { to, ...rest } = linkProps;

	return (
		<LinkNavAction
			to={disabled ? undefined : to}
			{...rest}
			data-disabled={disabled}
			css={[
				hubButtonStyle({ color, variant, size }),
				{
					// Align text in link the same way a button would.
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				},
			]}
		/>
	);
}
